var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M227.484 116.588V164.18L214.746 153.239C208.65 148.003 198.803 148.003 192.708 153.239L160.198 181.138C154.103 186.374 144.256 186.374 138.16 181.138L135.503 178.95C129.955 174.105 121.124 173.636 114.872 177.856L76.4234 203.645L75.5638 204.27C72.6723 198.018 71.1875 190.594 71.1875 182.076V116.588C71.1875 88.1417 88.1456 71.1836 116.592 71.1836H182.08C210.526 71.1836 227.484 88.1417 227.484 116.588Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.681 67.9531C220.789 64.0507 214.578 61.7422 207.817 61.7422C201.057 61.7422 194.736 64.1056 189.789 68.118C183.138 73.3396 178.961 81.5293 178.961 90.5984C178.961 95.9849 180.5 101.152 183.138 105.439C185.172 108.792 187.81 111.705 190.943 113.958C195.67 117.421 201.496 119.455 207.817 119.455C215.127 119.455 221.723 116.761 226.78 112.254C229.033 110.385 230.957 108.077 232.496 105.439C235.134 101.152 236.673 95.9849 236.673 90.5984C236.673 81.4194 232.386 73.2297 225.681 67.9531ZM207.817 104.339C207.817 96.7544 201.661 90.5984 194.076 90.5984C201.661 90.5984 207.817 84.4424 207.817 76.8573C207.817 84.4424 213.973 90.5984 221.558 90.5984C213.973 90.5984 207.817 96.7544 207.817 104.339Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.482 164.18V182.076C227.482 210.522 210.524 227.48 182.078 227.48H116.59C96.6625 227.48 82.2832 219.118 75.5625 204.27L76.4221 203.645L114.871 177.856C121.123 173.636 129.954 174.105 135.502 178.95L138.159 181.138C144.254 186.374 154.101 186.374 160.197 181.138L192.706 153.239C198.802 148.004 208.648 148.004 214.744 153.239L227.482 164.18Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature);
export default __webpack_public_path__ + "static/media/feature.a2822aedf98c26a135ddbef917f1e3f3.svg";
export { ForwardRef as ReactComponent };